import { getGoToFairePosCTA } from "./shared";
export var UnlinkingPosIA = function UnlinkingPosIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getGoToFairePosCTA;
        return (_getGoToFairePosCTA = getGoToFairePosCTA(context, strictLocalize)) === null || _getGoToFairePosCTA === void 0 ? void 0 : _getGoToFairePosCTA.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getGoToFairePosCTA2, _getGoToFairePosCTA2$;
        return (_getGoToFairePosCTA2 = getGoToFairePosCTA(context, strictLocalize)) === null || _getGoToFairePosCTA2 === void 0 ? void 0 : (_getGoToFairePosCTA2$ = _getGoToFairePosCTA2.getLink) === null || _getGoToFairePosCTA2$ === void 0 ? void 0 : _getGoToFairePosCTA2$.call(_getGoToFairePosCTA2);
      }
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return UNLINKING_POS(strictLocalize);
    },
    getDescription: function getDescription() {
      return [TO_DISCONNECT_YOUR_CURRENT_POS_INTEGRATION(strictLocalize), TO_RECONNECT_A_DIFFERENT_ACCOUNT(strictLocalize)];
    }
  };
};
var UNLINKING_POS = function UNLINKING_POS(strictLocalize) {
  return strictLocalize({
    id: "asarqc",
    defaultMessage: [{
      "type": 0,
      "value": "POS ontkoppelen"
    }]
  });
};
var TO_DISCONNECT_YOUR_CURRENT_POS_INTEGRATION = function TO_DISCONNECT_YOUR_CURRENT_POS_INTEGRATION(strictLocalize) {
  return strictLocalize({
    id: "DsdM7O",
    defaultMessage: [{
      "type": 0,
      "value": "Je kunt je huidige POS-integratie ontkoppelen door op de knop met het gebruikerspictogram in de rechterbovenhoek van het retailerportaal te klikken en de optie ‘Mijn POS [INTEGRATIENAAM]’ te selecteren. Klik op deze pagina in de rechterbovenhoek op ‘Instellingen’. Zodra je in je Instellingen bent, kun je naar beneden scrollen naar ‘POS [INTEGRATIENAAM] ontkoppelen’."
    }]
  });
};
var TO_RECONNECT_A_DIFFERENT_ACCOUNT = function TO_RECONNECT_A_DIFFERENT_ACCOUNT(strictLocalize) {
  return strictLocalize({
    id: "4fMVwv",
    defaultMessage: [{
      "type": 0,
      "value": "Om een ander account opnieuw te verbinden, kun je de pagina vernieuwen en gewoon op 'Verbinden met Square', 'Verbinden met Shopify' of 'Verbinden met Clover' klikken."
    }]
  });
};